// extracted by mini-css-extract-plugin
module.exports = {"content_list":"content_list-20FBfkSg"};